import { render, staticRenderFns } from "./LabelSearch.vue?vue&type=template&id=f1aa3ace&scoped=true&"
import script from "./LabelSearch.vue?vue&type=script&lang=js&"
export * from "./LabelSearch.vue?vue&type=script&lang=js&"
import style0 from "./LabelSearch.vue?vue&type=style&index=0&id=f1aa3ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1aa3ace",
  null
  
)

export default component.exports